module.exports = __webpack_public_path__ + "img/tate-stairway-masked-student.f221c8cb.jpg";